if (!customElements.get('qr-published-reviews')) {
  class QRPublishedReviews extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.track = this.querySelector('[data-review-track]');
      if (!this.track) return;
      this.cards = [];
      this.source = document.getElementById(this.dataset.sourceId);
      if (!this.source) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.position = this.querySelector('[data-review-position]');
      this.querySelector('[data-review-controls]').hidden = true;
      this.classList.add('qr-published-reviews-ready');
      this.dataset.playing = 'false';
      const schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {this.frame = null;this.update();});
      };
      this.track.addEventListener('scroll',schedule,{...options,passive:true});
      this.previous.addEventListener('click',()=>this.move(-1),options);
      this.next.addEventListener('click',()=>this.move(1),options);
      this.track.addEventListener('keydown',event=>{
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key==='Home'||event.key==='End') this.go(event.key==='Home'?0:this.lastIndex);
        else this.move(event.key==='ArrowLeft'?-1:1);
      },options);
      this.track.addEventListener('focusin',event=>{
        const card=event.target.closest('.qr-review-card');
        if (!card) return;
        const i=this.cards.indexOf(card),first=this.currentIndex;
        if (i<first) this.go(i,true);
        else if(i>=first+this.columns) this.go(i-this.columns+1,true);
      },options);
      this.track.addEventListener('touchstart',event=>{
        if(event.touches.length!==1)return;
        this.touch={x:event.touches[0].clientX,y:event.touches[0].clientY,left:this.track.scrollLeft};
      },{...options,passive:true});
      this.track.addEventListener('touchend',event=>{
        if(!this.touch||!event.changedTouches.length)return;
        const x=event.changedTouches[0].clientX-this.touch.x,y=event.changedTouches[0].clientY-this.touch.y;
        if(Math.abs(x)>60&&Math.abs(x)>Math.abs(y)*1.5){
          if(this.touch.left<2&&x>0)this.go(this.lastIndex);
          else if(this.touch.left>=this.maximum-2&&x<0)this.go(0);
        }
        this.touch=null;
      },{...options,passive:true});
      this.resize=new ResizeObserver(schedule);
      this.resize.observe(this.track);
      this.sourceObserver = new MutationObserver(()=>this.consume());
      this.sourceObserver.observe(this.source,{childList:true,subtree:true});
      document.addEventListener('stamped:reviews:widget:loaded',()=>this.consume(),options);
      document.addEventListener('visibilitychange',()=>{if(!document.hidden&&Date.now()-(this.fetchedAt||0)>300000)this.refreshSource();},options);
      window.addEventListener('pageshow',event=>{if(event.persisted)this.refreshSource();},options);
      this.refreshSource();
      document.fonts?.ready.then(()=>{if(this.ready)schedule();});
      this.update();
    }
    clearReviews(message){
      this.cards.forEach(card=>this.resize.unobserve(card));
      this.cards=[];
      this.track.replaceChildren();
      this.style.removeProperty('--review-track-height');
      this.querySelector('[data-review-controls]').hidden=true;
      this.querySelector('[data-review-feed-status]').textContent=message;
      this.dataset.feedState='loading';
    }
    refreshSource(){
      if(!this.ready)return;
      clearTimeout(this.sourceTimeout);clearInterval(this.sdkWait);
      this.clearReviews(this.dataset.loadingLabel);
      this.source.replaceChildren();
      const widget=document.createElement('div');
      widget.id='stamped-reviews-widget';
      widget.dataset.widgetType='full-page';
      widget.dataset.minRating='5';
      this.source.appendChild(widget);
      const reload=()=>{if(typeof window.StampedFn?.loadDisplayWidgets!=='function'||typeof window.jQueryStamped!=='function')return false;clearInterval(this.sdkWait);window.StampedFn.loadDisplayWidgets();return true;};
      if(!reload())this.sdkWait=setInterval(reload,250);
      this.sourceTimeout=setTimeout(()=>{
        if(this.dataset.feedState!=='ready'){
          clearInterval(this.sdkWait);
          this.clearReviews(this.dataset.errorLabel);
          this.dataset.feedState='error';
        }
      },20000);
    }
    consume(){
      if(!this.ready)return;
      const items=[...this.source.querySelectorAll('.stamped-review-card[id^="stamped-review-"]')];
      if(!items.length)return;
      const records=items.map((el,index)=>{
        const id=el.id.replace('stamped-review-',''),authorNode=el.querySelector('.stamped-reviews-author')?.cloneNode(true);
        authorNode?.querySelectorAll('*').forEach(e=>e.remove());
        const author=authorNode?.textContent.trim(),message=(el.querySelector('.original-review')||el.querySelector('.stamped-reviews-message'))?.textContent.trim();
        const rating=el.querySelectorAll('.stamped-reviews-rating .stamped-fa-star').length;
        const date=el.querySelector('.stamped-reviews-date')?.textContent.trim(),parts=date?.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        const iso=parts?`${parts[3]}-${parts[1].padStart(2,'0')}-${parts[2].padStart(2,'0')}`:'';
        return{id,author,message,rating,date,iso,index,verified:el.querySelector('.stamped-verified-label')?.dataset.verifiedType==='2'};
      }).filter(r=>/^\d+$/.test(r.id)&&r.author&&r.message&&r.rating===5&&r.iso);
      if(!records.length)return;
      records.sort((a,b)=>b.iso.localeCompare(a.iso)||a.index-b.index);
      const seen=new Set(),selected=records.filter(r=>{if(seen.has(r.id))return false;seen.add(r.id);return true;}).slice(0,10);
      const signature=JSON.stringify(selected);
      if(signature===this.signature&&this.cards.length)return;
      this.signature=signature;
      const previous=this.cards[this.currentIndex]?.dataset.reviewId;
      const fragment=document.createDocumentFragment(),template=this.querySelector('[data-review-template]');
      const excerpts={"165778641": "QuizRunners has helped alleviate some of the time crunch I experienced with my schedule.", "165747192": "We only use 5 rounds, but the crowd enjoys it!! […] Now, I only spend about 20 minutes prepping for each week. I LOVE IT!!!"};
      selected.forEach(r=>{
        const card=template.content.firstElementChild.cloneNode(true),full=r.message,excerpt=excerpts[r.id];
        const quote=excerpt&&excerpt.split(' […] ').every(s=>full.includes(s))?excerpt:full;
        card.dataset.reviewId=r.id;
        card.querySelector('blockquote').cite='https://quizrunners.com/a/review/all#stamped-review-'+r.id;
        card.querySelector('blockquote p').textContent='“'+quote+'”';
        card.querySelector('strong').textContent=r.author;
        const stars=card.querySelector('.qr-review-stars');stars.setAttribute('aria-label',this.dataset.ratingLabel.replace('__RATING__',r.rating));
        stars.querySelectorAll('svg').forEach((star,i)=>star.classList.toggle('qr-review-star-empty',i>=r.rating));
        const date=card.querySelector('time');date.dateTime=r.iso;date.textContent=new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}).format(new Date(r.iso+'T12:00:00Z'));
        card.querySelector('[data-review-verified]').hidden=!r.verified;
        const link=card.querySelector('.qr-review-source');link.href=this.dataset.sourceUrl+'#stamped-review-'+r.id;link.setAttribute('aria-label',this.dataset.readLabel.replace('__NAME__',r.author));
        card.querySelector('.qr-review-excerpt').hidden=quote===full;
        fragment.appendChild(card);
      });
      this.cards.forEach(card=>this.resize.unobserve(card));
      this.track.replaceChildren(fragment);this.cards=[...this.track.children];this.cards.forEach(card=>this.resize.observe(card));
      this.querySelector('[data-review-controls]').hidden=this.cards.length<2;
      this.querySelector('[data-review-feed-status]').textContent=this.dataset.readyLabel;
      this.dataset.feedState='ready';this.fetchedAt=Date.now();clearTimeout(this.sourceTimeout);
      const restored=this.cards.findIndex(card=>card.dataset.reviewId===previous);this.go(Math.max(0,restored),true);this.update();
    }

    get columns(){return Math.max(1,Number(getComputedStyle(this.track).getPropertyValue('--review-columns'))||1);}
    get lastIndex(){return Math.max(0,this.cards.length-this.columns);}
    get maximum(){return Math.max(0,this.track.scrollWidth-this.track.clientWidth);}
    get step(){return this.track.clientWidth/this.columns;}
    get currentIndex(){return Math.max(0,Math.min(this.lastIndex,Math.round(this.track.scrollLeft/this.step)));}
    go(index,instant=false){
      this.track.scrollTo({left:Math.max(0,Math.min(this.lastIndex,index))*this.step,behavior:instant||this.motion.matches?'instant':'smooth'});
    }
    move(direction){
      const current=this.currentIndex;
      this.go(direction>0?(current>=this.lastIndex?0:current+1):(current<=0?this.lastIndex:current-1));
    }
    update(){
      if(!this.cards.length)return;
      const index=this.currentIndex,visible=this.cards.slice(index,index+this.columns);
      const height=Math.ceil(Math.max(...visible.map(card=>card.getBoundingClientRect().height)));
      this.style.setProperty('--review-track-height',height+'px');
      const label=(this.columns===1?this.dataset.positionLabel:this.dataset.rangeLabel).replace('__INDEX__',index+1).replace('__START__',index+1).replace('__END__',Math.min(index+this.columns,this.cards.length)).replace('__TOTAL__',this.cards.length);
      if(this.position.textContent!==label)this.position.textContent=label;
    }
    disconnectedCallback(){this.ready=false;this.abort?.abort();this.resize?.disconnect();this.sourceObserver?.disconnect();clearTimeout(this.sourceTimeout);clearInterval(this.sdkWait);cancelAnimationFrame(this.frame);this.frame=null;}
  }
  customElements.define('qr-published-reviews',QRPublishedReviews);
}

